import { RouteCodes } from '@core/config/route-codes';
import { POSITION_ROUTES_TREE } from '@core/config/routes-tree';
import { StepConfigModel } from '@models/wizard/steps-config.model';

export const STEPS_CONFIG: {
  [stepCode: string]: StepConfigModel;
} = {
  ['INTRO']: {
    path: POSITION_ROUTES_TREE[RouteCodes.instructions].path
  },
  ['PRIVACY']: {
    path: POSITION_ROUTES_TREE[RouteCodes.surveyCollection].path
  },
  ['DOCS_PREC']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['PRIMARY_DATA']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['EMAIL']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['PHONE']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['DOC_IDENTITY']: {
    path: POSITION_ROUTES_TREE[RouteCodes.documentsRequest].path
  },
  ['CHECK_INFO_IDENT']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['IDENTITY']: {
    path: POSITION_ROUTES_TREE[RouteCodes.recognition].path
  },
  ['INTEGRATION_DATA']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['CUSTOMER_ADDRESS']: {
    path: POSITION_ROUTES_TREE[RouteCodes.address].path,
    params: { addressTypes: ['domicile'] }
  },
  ['RESIDENCE_ADDRESS']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path,
    params: { mode: 'readonly' }
  },
  ['RESIDENCE_ADDRESS_EDIT']: {
    path: POSITION_ROUTES_TREE[RouteCodes.address].path,
    params: { addressTypes: ['residence'] }
  },
  ['STATEMENT_ADDRESS']: {
    path: POSITION_ROUTES_TREE[RouteCodes.address].path,
    params: { addressTypes: ['shipping'] }
  },
  ['CARD_CONFIRM']: {
    path: POSITION_ROUTES_TREE[RouteCodes.cardConfirm].path
  },
  ['IOSI_PROGRAM']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['QUESTIONARY']: {
    path: POSITION_ROUTES_TREE[RouteCodes.surveyCollection].path
  },
  ['CONTRACT_SIGNATURE']: {
    path: POSITION_ROUTES_TREE[RouteCodes.contractSigning].path,
    params: { avoidExit: true }
  },
  ['END_ONBOARDING']: {
    path: POSITION_ROUTES_TREE[RouteCodes.release].path
  }
};
